export default __webpack_public_path__ + "static/media/blog_inner_15.9f7808d4.png";